import toast from "react-hot-toast";
import instance from "../../network/index"; // Import your axios instance
import { handleToast } from "@/network/helper";

const getTasks = async (queryPrams = "") => {
  try {
    const response = await instance.get(`/api/v1/tasks?${queryPrams}`);
    return response.data;
  } catch (error) {
    console.error("Login error:", error);
    if (error.response) {
      console.error(
        `Error status: ${error.response.status}`,
        error.response.data
      );
    }
    throw error; // Rethrow the error if needed for further handling
  }
};

const getTaskById = async (id) => {
  try {
    const response = await instance.get(`/api/v1/tasks/${id}`);
    return response.data;
  } catch (error) {
    console.error("Login error:", error);
    if (error.response) {
      console.error(
        `Error status: ${error.response.status}`,
        error.response.data
      );
    }
    throw error; // Rethrow the error if needed for further handling
  }
};

const updateTaskById = async (id, payload) => {
  try {
    const response = await instance.patch(`/api/v1/tasks/${id}`, payload);
    return response.data;
  } catch (error) {
    return error;
  }
};
const editedTaskById = async (id, payload) => {
  try {
    const response = await instance.patch(`/api/v1/tasks/${id}/edit`, payload);
    return response.data;
  } catch (error) {
    return error;
  }
};
const deleteTaskById = async (id) => {
  try {
    const response = await instance.delete(`/api/v1/tasks/${id}`);

    if (response.status === 204) {
      toast.success("Task deleted successfully");
      return { message: "", status: 200 };
    }

    return response.data; // Return API response if not 204
  } catch (error) {
    handleError(error, "Something went wrong");
    return error; // Return error for further handling
  }
};


const addCommentByTaskId = async (id, payload) => {
  try {
    const response = await instance.post(
      `/api/v1/tasks/${id}/comments`,
      payload
    );
    return response.data;
  } catch (error) {
    // Check if error has a response, message, or other useful info
    if (error.response) {
      // Axios error response has a response property with data and status
      console.error("Response error:", error.response);
    } else if (error.request) {
      // This means the request was made but no response was received
      console.error("Request error:", error.request);
    } else {
      // Generic error message
      console.error("Error message:", error.message);
    }
    return error; // Ensure you return the error object for further handling
  }
};

const createTask = async (payload) => {
  try {
    const response = await instance.post(`/api/v1/tasks`, payload);
    return response.data;
  } catch (error) {
    console.error("Login error:", error);
    if (error.response) {
      console.error(
        `Error status: ${error.response.status}`,
        error.response.data
      );
    }
    throw error; // Rethrow the error if needed for further handling
  }
}
// Centralized error handler
const handleError = (err, defaultMessage) => {
  console.error(defaultMessage, err);
  const message =
    err.response?.data?.message || err.message || defaultMessage;
  handleToast({ err: { response: { data: { message } } } });
};




const getNotifications = async () => {
  try {
    const response = await instance.get(`/api/v1/notifications`);
    return response.data;
  } catch (error) {
    console.error("Login error:", error);
    if (error.response) {
      console.error(
        `Error status: ${error.response.status}`,
        error.response.data
      );
    }
    throw error; // Rethrow the error if needed for further handling
  }
};



const readNotifications = async () => {
  try {
    const response = await instance.get(`/api/v1/notifications/read`);
    return response.data;
  } catch (error) {
    console.error("Login error:", error);
    if (error.response) {
      console.error(
        `Error status: ${error.response.status}`,
        error.response.data
      );
    }
    throw error; // Rethrow the error if needed for further handling
  }
};








export { getTasks, getTaskById, updateTaskById, addCommentByTaskId, deleteTaskById, createTask, editedTaskById, readNotifications,  getNotifications };
